import type { Fragment } from '../translations';

export const observation: Fragment = {
  fr: {
    'obs.stat.live': 'Processus en service',
    'obs.stat.kpis': 'KPIs suivis',
    'obs.stat.offTarget': 'Hors cible',
    'obs.stat.stale': 'Sans mesure > 30 j',
    'obs.tab.byProcess': 'Par processus',
    'obs.tab.byKpi': 'Par KPI',
    'obs.tab.offTarget': 'Hors cible',
    'obs.target': 'cible {t}',
    'obs.noMeasure': 'aucune mesure',
    'obs.lastMeasure': 'dernière mesure il y a {n} j',
    'obs.configureSource': 'Configurer la source',
    'obs.noKpis': 'Aucun KPI défini.',
    'obs.empty': 'Aucun processus n\'est encore en service. Les KPIs apparaîtront dès qu\'un processus atteint l\'étape 8.',
    'obs.usedByN': '{n} processus',
    'obs.allOnTarget': 'Tout est dans la cible.',
  },
  en: {
    'obs.stat.live': 'Live processes',
    'obs.stat.kpis': 'Tracked KPIs',
    'obs.stat.offTarget': 'Off target',
    'obs.stat.stale': 'No measure > 30 d',
    'obs.tab.byProcess': 'By process',
    'obs.tab.byKpi': 'By KPI',
    'obs.tab.offTarget': 'Off target',
    'obs.target': 'target {t}',
    'obs.noMeasure': 'no measure',
    'obs.lastMeasure': 'last measure {n} d ago',
    'obs.configureSource': 'Configure the source',
    'obs.noKpis': 'No KPI defined.',
    'obs.empty': 'No process is live yet. KPIs appear as soon as a process reaches step 8.',
    'obs.usedByN': '{n} processes',
    'obs.allOnTarget': 'Everything is on target.',
  },
};
